import styled from "styled-components";
import { RASelect, RATypography } from "@/components/customs";
import { RAImage, RATextInput, RAButtonPrimary } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { CONTACT_TYPE, CONTACT_TYPE_OPTIONS, NOTIFICATION_TYPE, REGEX_EMAIL, REGEX_PHONE } from "@/config/constants";

import { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { createUserContact } from "@/stores/apis/apiSettings";
import { toast } from "@/modules/toast";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { HeaderSection } from "../../Cards";
const { useBreakpoint } = Grid;
const initForm = {
	first_name: "",
	type: CONTACT_TYPE.JET_ONE_SUITE,
	last_name: "",
	phone: "",
	email: "",
	note: "",
};

export function ServiceJ1SGetInTouchUs({ get_in_touch_with_us = {} }) {
	const screens = useBreakpoint();
	const [ref, { isVisible }] = useTrackVisibility();
	const [formContact, setFormContact] = useState(initForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);

	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	const validateFormContact = () => {
		let errs = {};
		if (!formContact.first_name) {
			errs.first_name = "Please enter first name";
		}
		if (!formContact.last_name) {
			errs.last_name = "Please enter last name";
		}
		if (!formContact.type) {
			errs.type = "Please select type";
		}
		if (!formContact.phone) {
			errs.phone = "Please enter your phone";
		} else if (!isPossiblePhoneNumber(formContact.phone)) {
			errs.phone = "Please enter valid phone number";
		}
		if (!formContact.email) {
			errs.email = "Please enter your email";
		} else if (!REGEX_EMAIL.test(formContact.email)) {
			errs.email = "Please enter valid email";
		}
		if (!formContact.note) {
			errs.note = "Please enter special request";
		}

		if (!isEmpty(errs)) {
			setErrors(errs);
			return false;
		}

		return true;
	};

	const handleSubmit = async () => {
		let validForm = validateFormContact();
		if (!validForm || loading) return;

		setLoading(true);

		let response = await createUserContact(formContact);
		if (response && response.success) {
			toast({
				type: NOTIFICATION_TYPE.SUCCESS,
				description: "Thanks for reaching out! We've got your message and will be in touch soon.",
			});
			setFormContact({ ...initForm });
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Your message failed to send. Please try again later.",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 300);
	};

	const getHeightBanner = () => {
		let height = "100%";
		if (screens.md) {
			height = "100%";
		} else if (screens.sm) {
			height = "100%";
		} else if (screens.xs) {
			height = "210px";
		}
		return height;
	};

	return (
		<HomeUtilitiesContainer ref={ref}>
			<EachCol
				className="image-column"
				xxl={{ span: 12, order: 1 }}
				xl={{ span: 12, order: 1 }}
				lg={{ span: 12, order: 1 }}
				md={{ span: 24, order: 2 }}
				xs={{ span: 24, order: 2 }}
			>
				<ImageContainer style={{ opacity: visible ? 1 : 0 }}>
					<EachImage className={`${visible && "animate__animated animate__fadeInUp"}`}>
						<RAImage
							url={
								screens.xs
									? get_in_touch_with_us?.mobile_banner
									: get_in_touch_with_us?.desktop_banner ||
										PATH_PUBLIC_IMAGES.service_j1s_provision_luxury_4
							}
							width="100%"
							height={getHeightBanner()}
							borderRadius="12px"
							className="image-left"
						/>
					</EachImage>
				</ImageContainer>
			</EachCol>
			<EachCol
				className="introduction-column"
				xxl={{ span: 12, order: 2 }}
				xl={{ span: 12, order: 2 }}
				lg={{ span: 12, order: 2 }}
				md={{ span: 24, order: 1 }}
				xs={{ span: 24, order: 1 }}
				style={{ marginTop: !screens.xs ? "40px" : "0px" }}
			>
				<HeaderSection
					title={get_in_touch_with_us?.title || ""}
					description={get_in_touch_with_us?.sub_title || ""}
				/>
				<WrapperSection style={{ opacity: visible ? 1 : 0 }}>
					<div className={`${visible && "animate__animated animate__fadeInUp"}`}>
						<Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
							<Col md={12} xs={24}>
								<RATextInput
									title="First name"
									placeholder=" "
									value={formContact.first_name}
									onChange={(val) => {
										setFormContact({
											...formContact,
											first_name: val,
										});
										setErrors({});
									}}
									error={errors.first_name}
								/>
							</Col>
							<Col md={12} xs={24}>
								<RATextInput
									title="Last name"
									placeholder=" "
									value={formContact.last_name}
									onChange={(val) => {
										setFormContact({
											...formContact,
											last_name: val,
										});
										setErrors({});
									}}
									error={errors.last_name}
								/>
							</Col>
						</Row>
					</div>
					<div
						className={`${visible && "animate__animated animate__fadeInUp"}`}
						style={{ animationDuration: "1.5s" }}
					>
						<Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
							<Col md={12} xs={24}>
								<RATypography color="#595959" variant="sub-heading4" bottom={8}>
									Type
								</RATypography>
								<RASelect
									options={CONTACT_TYPE_OPTIONS}
									value={formContact.type}
									onChange={(val) => {
										setFormContact({
											...formContact,
											type: val,
										});
										setErrors({});
									}}
									error={errors.type}
								/>
							</Col>
							<Col md={12} xs={24}>
								<RATextInput
									title="Your phone number"
									placeholder=" "
									type="phone"
									value={formContact.phone}
									onChange={(val) => {
										setFormContact({
											...formContact,
											phone: val,
										});
										setErrors({});
									}}
									error={errors.phone}
								/>
							</Col>
						</Row>
					</div>
					<div
						className={`${visible && "animate__animated animate__fadeInUp"}`}
						style={{ animationDuration: "2s" }}
					>
						<Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
							<Col span={24}>
								<RATextInput
									title="Your email"
									placeholder=" "
									value={formContact.email}
									onChange={(val) => {
										setFormContact({
											...formContact,
											email: val,
										});
										setErrors({});
									}}
									error={errors.email}
								/>
							</Col>
						</Row>
					</div>
					<div
						className={`${visible && "animate__animated animate__fadeInUp"}`}
						style={{ animationDuration: "2.5s" }}
					>
						<Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
							<Col span={24}>
								<RATextInput
									type="textarea"
									title="Message"
									placeholder=" "
									value={formContact.note}
									onChange={(val) => {
										setFormContact({
											...formContact,
											note: val,
										});
										setErrors({});
									}}
									error={errors.note}
								/>
							</Col>
						</Row>
					</div>
					<div
						className={`${visible && "animate__animated animate__fadeInUp"}`}
						style={{ animationDuration: "2.5s" }}
					>
						<Row gutter={[20, 20]} justify={screens?.xl ? "start" : "center"} style={{ marginTop: "30px" }}>
							<Col>
								<RAButtonPrimary
									title="SUBMIT"
									width="180px"
									onClick={handleSubmit}
									loading={loading}
								/>
							</Col>
						</Row>
					</div>
				</WrapperSection>
			</EachCol>
		</HomeUtilitiesContainer>
	);
}

const ImageContainer = styled.div`
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 400px 300px;
	gap: 8px;

	@media (max-width: 575px) {
		grid-template-rows: auto;
	}
`;
const EachImage = styled.div`
	&:first-child {
		grid-column: 1/8;
		grid-row: 1/3;
	}
	&:nth-child(2) {
		grid-column: 4/6;
		grid-row: 1/2;
	}
	&:nth-child(3) {
		grid-column: 4/6;
		grid-row: 2/3;
	}
`;
const HomeUtilitiesContainer = styled(Row)`
	/* width: 100%; */
	/* max-width: 1442px; */
	.image-column {
		padding-right: 30px;
	}
	.introduction-column {
		padding-left: 30px;
	}

	@media (max-width: 992px) {
		.image-column {
			padding-right: 0;
		}
		.introduction-column {
			padding-left: 0;
		}
	}
`;
const EachCol = styled(Col)`
	padding-top: 20px;
`;
const WrapperSection = styled.div`
	padding: 12px 0px;
	display: flex;
	flex-direction: column;
`;
